import { jsx as _jsx } from "react/jsx-runtime"; // eslint-disable-next-line import/order

import * as commonStyle from '../css/common/common.css';
import clsx from 'clsx';
import { ensureCommonImported } from '../css/common/commonTracker';
import { FullMetalUiThemeContext } from './FullMetalUiThemeContext';
import { RootFull } from './RootFull';

if (process.env.NODE_ENV === 'development') {
  ensureCommonImported();
}

export const FullMetalUiProvider = ({
  env,
  theme,
  useBodyBackground,
  headWrapper,
  children
}) => {
  return _jsx(FullMetalUiThemeContext.Provider, Object.assign({
    value: Object.assign(Object.assign({}, theme), {
      typographyClassName: commonStyle.typographyRoot
    })
  }, {
    children: _jsx("div", Object.assign({
      className: clsx(theme.tokensClassName, commonStyle.typographyRoot, {
        [commonStyle.bodyBackground]: useBodyBackground
      })
    }, {
      children: _jsx(RootFull, Object.assign({
        env: env,
        headWrapper: headWrapper
      }, {
        children: children
      }))
    }))
  }));
};
FullMetalUiProvider.displayName = 'FullMetalUiProvider';
//# sourceMappingURL=FullMetalUiProvider.js.map